import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getInsertionOrderCardStyles, getThresholdProgressBarStyles, getTopKeyCardStyles } from '../../styles/top-key-card';
import { formatCurrency } from '../../utils';

export function MessageItem({ message, severity, className }) {
  const classes = useDefaultStyles(getTopKeyCardStyles);
  return (<div className={classnames('amount-node-message-item', classes.MessageItem, classes[`Icon-Severity-${severity}`], className)}>{message}</div>);
}
MessageItem.propTypes = {
  severity: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
  className: PropTypes.string,
};
MessageItem.defaultProps = {
  className: null,
};

export function AmountNode({
  i18n, currencyCode, amount, suffixKey, hint, message,
}) {
  const classes = useDefaultStyles(getTopKeyCardStyles);
  if (!_.isNumber(amount)) {
    return null;
  }
  const formattedValue = formatCurrency({
    i18n, value: amount, currencyCode, options: { compact: 'short', maximumFractionDigits: 2 },
  });

  return (
    <div className={classnames('amount-node')}>
      <div className={classes.AmountNodeInfo}>
        <div className={classnames('amount-node-value-node', classes.AmountNodeValueNode)}>
          <span className={classnames('amount-node-value', classes.AmountNodeValue)}>{formattedValue}</span>
          {suffixKey && <span className={classnames('amount-node-suffix', classes.AmountNodeSuffix)}>{i18n.getString(suffixKey)}</span>}
        </div>
        {hint && <span className={classnames('amount-node-hint', classes.AmountHint)}>{hint}</span>}
      </div>
      {message && <MessageItem message={message.text} severity={message.severity} />}
    </div>
  );
}

AmountNode.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  currencyCode: PropTypes.string.isRequired,
  amount: PropTypes.number,
  suffixKey: PropTypes.string,
  hint: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  message: PropTypes.shape({
    severity: PropTypes.number,
    text: PropTypes.string,
  }),
};
AmountNode.defaultProps = {
  amount: null,
  suffixKey: null,
  hint: null,
  message: null,
};

export function ThresholdProgressBar({ percentage }) {
  const classes = useDefaultStyles(getThresholdProgressBarStyles, { percentage });

  return (
    <div className={classnames('threshold-progress-bar', classes.Container)} data-percentage={percentage}>
      <div className={classnames('threshold-progress-bar-bar', classes.Bar)} />
    </div>
  );
}
ThresholdProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
};

export function InsertionOrderItem({
  i18n, itemName, itemKey, itemValue, message, severity,
}) {
  const classes = useDefaultStyles(getInsertionOrderCardStyles);

  return (
    <div className={classnames('insertion-order-item', classes.Item, `insertion-order-item-${itemName}`)}>
      <div className="insertion-order-item-names">
        <div className={classnames('insertion-order-item-name', classes.ItemName)}>{i18n.getString(itemKey)}</div>
        {message && <MessageItem message={message} severity={severity} />}
      </div>
      <div className={classnames('insertion-order-item-value', classes.ItemValue)}>{itemValue}</div>
    </div>
  );
}
InsertionOrderItem.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  itemName: PropTypes.string,
  itemKey: PropTypes.string.isRequired,
  itemValue: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  message: PropTypes.string,
  severity: PropTypes.number,
};
InsertionOrderItem.defaultProps = {
  itemName: null,
  message: null,
  severity: null,
};
